import { hydrateRoot } from "react-dom/client";
import { I18nProvider } from "@/components/I18nProvider";
import { PublicProfile } from "@/components/PublicProfile";
import { getMessages } from "@/lib/i18n";
import { PUBLIC_REACT_IDENTIFIER_PREFIX, type PublicPageBootstrap } from "@/lib/public-delivery";
import "@fontsource-variable/fraunces/opsz.css";
import "@fontsource-variable/fraunces/opsz-italic.css";
import "@fontsource-variable/archivo/wdth.css";
import "@fontsource-variable/jetbrains-mono/wght.css";
import "@/app/globals.css";
import "@/app/themes-v2.css";
import "@/app/themes-experimental.css";
import "@/app/themes-structured.css";

const root = document.getElementById("public-profile-root");
const bootstrapNode = document.getElementById("public-profile-bootstrap");

if (root && bootstrapNode?.textContent) {
  const bootstrap = JSON.parse(bootstrapNode.textContent) as PublicPageBootstrap;
  hydrateRoot(
    root,
    <I18nProvider locale={bootstrap.locale} messages={getMessages(bootstrap.locale)}>
      <PublicProfile
        profile={bootstrap.document.profile}
        presentation={bootstrap.document.presentation}
        owner={false}
        compiledMarkdown={bootstrap.compiledMarkdown}
      />
    </I18nProvider>,
    { identifierPrefix: PUBLIC_REACT_IDENTIFIER_PREFIX }
  );
}
